import { useMutation, useQuery } from "@graphcommerce/graphql";
import { ProductInterface } from "@graphcommerce/graphql-mesh";
import { useCustomerSession } from "@graphcommerce/magento-customer";
import { ProductListItemFragment } from "@graphcommerce/magento-product";
import { GetIsInWishlistsDocument } from "@graphcommerce/magento-wishlist";
import { useContext, useEffect, useState } from "react"
import { ModalContext } from "../../context/context";
import { useLoading } from "../../context/loadingContext";
import { useWishlist } from "../../context/wishlistContext";
import { addProductsToWishlistDocument } from "../../graphql/wishlist/addProductsToWishlist.gql";
import { getCustomerWishlistDocument } from "../../graphql/wishlist/getCustomerWishlist.gql";
import { removeProductsFromWishlistDocument } from "../../graphql/wishlist/removeProductsFromWishlist.gql";
import AuthForms from "../AuthForms";
import IconHeart from "../icons/IconHeart";
import IconHeartFill from "../icons/IconHeartFill";
import AddToWishlistFormContent from "./AddToWishlistFormContent";

type ProductAddToWishlistBtnProps = (ProductListItemFragment | ProductInterface) & {
  small_image?: {
    url?: string | null | undefined
    label?: string | null | undefined
  } | null;
  size?: number;
  color?: string
}


export default function ProductAddToWishlistBtn({ size = 18, color = 'text-light-200', ...props }: ProductAddToWishlistBtnProps) {
  const [add, setAdd] = useState<null | number | string>(null);
  const { loggedIn } = useCustomerSession();
  const { data } = useQuery(getCustomerWishlistDocument);
  const { items, handleRefetch, wishlistId, showPopup } = useWishlist()
  const useModal = useContext(ModalContext);
  const { setLoading } = useLoading()
  const [removeProductFromWishlist] = useMutation(removeProductsFromWishlistDocument)
  const [addToWishlist] = useMutation(addProductsToWishlistDocument);

  const handleAddToWishlist = (description: string | null, category_id) => {
    setLoading(true);
    addToWishlist({
      variables: {
        wishlistId,
        wishlistItems: [
          {
            quantity: 1,
            sku: props.sku!,
            description,
            wishlist_category_id: category_id === 'favs' ? null : category_id
          }
        ]
      }
    }).then(({ data, errors }) => {
      if (data?.addProductsToWishlist?.wishlist) {

        handleRefetch();
        useModal.close && useModal.close()
      } else if (data?.addProductsToWishlist?.user_errors.length) {
        alert(data?.addProductsToWishlist?.user_errors[0]?.message)
      }
    }).catch(err => alert(err.message)).finally(() => setLoading(false))
  }

  const handleRemoveFromWishlist = () => {
    setLoading(true)
    removeProductFromWishlist(({
      variables: {
        wishlistId,
        wishlistItemsIds: [
          add as string
        ]
      }
    })).then(({ data }) => {
      if (!data?.removeProductsFromWishlist?.user_errors.length) {
        handleRefetch()
      }
    }).catch(err => alert(err.message)).finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loggedIn) {
      setAdd(null)
    } else {
      // let item = data?.customer?.wishlist_v2?.items_v2?.items.find(i => i?.product?.sku === props.sku);
      const item2 = items?.find(i => i?.products?.find(c => c?.sku == props.sku));
      if (item2) {
        const c = item2.products?.find(c => c?.sku == props.sku)
        setAdd(c?.wishlist_item_id!)
      } else {
        setAdd(null);
      }
    }
  }, [loggedIn, data, props.sku, items])
  const handleClick = () => {
    if (loggedIn) {
      if (showPopup) {
        useModal.set && useModal.set({
          content: <AddToWishlistFormContent {...props}
            onClose={() => { useModal.close && useModal.close() }}
            handleAddToWishlist={handleAddToWishlist}
          />, open: true, title: '', position: 'center', width: 'md:max-w-[600px] !p-0'
        });
      } else {
        handleAddToWishlist(null, null)
      }
    } else {
      useModal.set && useModal?.set({ content: <AuthForms activeForm='login' stayAtPage />, open: true, title: '', position: 'center', width: 'max-w-sm' })
    }
  }
  return (
    <>
      {!add ? <IconHeart
        width={size}
        height={size}
        className={`cursor-pointer  ${color}`}
        onClick={handleClick} />
        : <IconHeartFill width={size} height={size} className={`cursor-pointer ${color}`} onClick={() => handleRemoveFromWishlist()} />}
    </>
  )
}

